import * as actionTypes from '../Action/BackboneAction';
import config from '../../config';
import { BackboneActionTypes } from '../Action/BackboneAction';

export const initialState = {
    isOpen: 'dashboard', //for active default menu
    fontFamily: config.fontFamily,
    borderRadius: config.borderRadius,
    navType: config.theme,
    locale: config.i18n,
    rtlLayout: false, // rtlLayout: config.rtlLayout,
    opened: true,
    Customise_Sidebar_Open:false,
    ShowBreadcrumb:true
};

const customizationReducer = (state = initialState, action :BackboneActionTypes) => {
    switch (action.type) {
        case actionTypes.MENU_OPEN:
            return {
                ...state,
                isOpen: action.Data
            };
        case actionTypes.MENU_TYPE:
            return {
                ...state,
                navType: action.Data
            };
        case actionTypes.THEME_LOCALE:
            return {
                ...state,
                locale: action.Data
            };
        case actionTypes.THEME_RTL:
            return {
                ...state,
                rtlLayout: action.Data
            };
        case actionTypes.SET_MENU:
            return {
                ...state,
                opened: action.Data
            };
        case actionTypes.SET_FONT_FAMILY:
            return {
                ...state,
                fontFamily: action.Data
            };
        case actionTypes.SET_BORDER_RADIUS:
            return {
                ...state,
                borderRadius: action.Data
            };
        case actionTypes.SET_CUSTOMISE_SIDEBAR_OPEN:             
            return {
                ...state,
                Customise_Sidebar_Open: action.Data
            };
        case actionTypes.SET_SHOW_BREADCRUMB:           
            return {
                ...state,
                ShowBreadcrumb: action.Data
            };
        default:
            return state;
    }
};

export default customizationReducer;
